<template>
    <f7-page
        name="Tracker Detail"
        class="onboardingBg"
    >
        <f7-navbar
            inner
            large
            title-large="My Bookmarks"
            no-hairline
            large-transparent
            inner-class="onboardingBg"
        >

            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>My Bookmarks</f7-nav-title>
            <f7-nav-right />
        </f7-navbar>
        <f7-list v-if="myBookmarks.length === 0 && isLoaded">
            <f7-list-item :title="'You don\'t have any bookmarks yet. '" />
        </f7-list>
        <f7-list
            v-else
            media-list
        >

            <sequential-entrance from-bottom>
                <template v-for="(bookmark, index) in myBookmarks">
                    <unit-card
                        :unit="unitsIndex[bookmark.unit.id] || bookmark.unit"
                        :key="`bookmark-${index}`"
                        :home="true"
                        :in-card="true"
                        :index="index"
                        :pack="myBookmarks"
                    />
                </template>
            </sequential-entrance>
        </f7-list>
    </f7-page>
</template>

<script>
import UnitCard from '../components/unitCard.vue';

export default {
    store: ['api', 'topics', 'topicsIndex', 'unitsIndex'],
    components: {
        UnitCard
    },
    data () {
        return {
            myBookmarks: [],
            isLoaded: false
        };
    },
    created: function () {
        this.getMyBookmarks();
    },
    mounted: function () { },
    methods: {
        goToInPopup: function (url) {
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 150);
            //f7.statusbar.setTextColor('white');
        },
        findPagePosition: function (bookmark) {
            for (let i = 0; i < bookmark.unit.slides.length; i++) {
                const slide = bookmark.unit.slides[i];
                if (bookmark.slideId === slide.id) {
                    return i + 1;
                }
            }
        },
        getMyBookmarks: function () {
            this.$http.get(`${this.api}/bookmarks`).then(response => {
                this.myBookmarks = response.body;
                // dirty reactivity hack
                for (let i = 0; i < this.myBookmarks.length; i++) {
                    const b = this.myBookmarks[i];
                    b.unit.bookmarked = true;
                    if (this.unitsIndex[b.unit.id]) {
                        Vue.set(this.unitsIndex[b.unit.id], 'bookmarked', true);
                    }
                }
                this.isLoaded = true;
            }, () => {
            });
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
</style>
